import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronRight } from "@fortawesome/free-solid-svg-icons";
import "./PersistentDisclaimer.css";

function getInitialExpandedState(storageKey) {
  try {
    const storedCollapsedState = localStorage.getItem(storageKey);
    if (storedCollapsedState === null) {
      return false;
    }
    return storedCollapsedState !== "true";
  } catch {
    return false;
  }
}

export default function PersistentDisclaimer({
  storageKey,
  title,
  children,
  className,
}) {
  const [isExpanded, setIsExpanded] = useState(() => getInitialExpandedState(storageKey));
  const contentId = `${storageKey}-content`;

  useEffect(() => {
    try {
      localStorage.setItem(storageKey, String(!isExpanded));
    } catch {
      // localStorage may be unavailable.
    }
  }, [isExpanded, storageKey]);

  return (
    <section
      className={`persistent-disclaimer w-full text-left text-sm text-base-darkest leading-relaxed ${className}`.trim()}
      style={{ width: "100%", textAlign: "left" }}
    >
      <button
        type="button"
        aria-expanded={isExpanded}
        aria-controls={contentId}
        onClick={() => setIsExpanded((value) => !value)}
        className="persistent-disclaimer__summary w-full cursor-pointer text-left font-bold"
      >
        <FontAwesomeIcon
          icon={isExpanded ? faChevronDown : faChevronRight}
          className="persistent-disclaimer__chevron"
          aria-hidden="true"
        />
        <span>{title}</span>
      </button>
      {isExpanded ? (
        <div id={contentId} className="persistent-disclaimer__content pt-2 text-left" style={{ textAlign: "left" }}>
          {children}
        </div>
      ) : null}
    </section>
  );
}

PersistentDisclaimer.propTypes = {
  storageKey: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

PersistentDisclaimer.defaultProps = {
  className: "",
};
